<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Указания по заполнению журнала
    </div>

    <div>
      <p>1. Записи в журнале должны производиться непосредственно у места бетонирования. Ведение черновых записей на отдельных листах, тетрадях и т.д. с последующим переписыванием в журнал запрещается.</p>
      <p>2. Заданные характеристики бетона записываются по данным подбора его состава бетонной лабораторией.</p>
      <p>3. Акты на изготовление контрольных образцов составляются на каждые 25 м3 уложенного бетона, но не менее, чем на одну полость оболочки, скважины, включая уширение.</p>
      <p>4. Над таблицей должна быть записана характеристика объекта бетонирования, которая для оболочек включает в себя следующие показатели: наружный диаметр оболочки, толщину её стенки, длину, наклон оболочки, диаметр скважины, диаметр уширения, проектную отметку верха бетона. Для колодцев должны быть указаны геометрические размеры в плане и высоте шахт и перемычек и отметка верха бетона. Для котлованов указывают геометрические размера в плане и высоте шахт и отметка верха бетона.</p>
      <p>
        5. В исполнительной таблице подлежат регистрации следующие показатели:<br />
        в графе 1 - порядковые номера записи;<br />
        в графе 2 - число, месяц и время записи;<br />
        в графе 3 - время между записями (не реже, чем через 1 час);<br />
        в графе 4 - сведения о ходе бетонирования и фактические характеристики бетонной смеси (состав смеси, водоцементное отношение, подвижность, относительное водоотделение);<br />
        в графе 5 - номера бетонолитных труб;<br />
        в графе 6 - диаметры бетонолитных труб,<br />
        в графе 7 - количество бетона (м3), уложенного в блок (записывается нарастающим шагом);<br />
        в графе 8 - средняя интенсивность бетонирования в период между записями;<br />
        в графе 9 - точка отсчёта - отметка верха оболочки, дна скважины, дна котлована;<br />
        в графе 10 - отметка грунта в полости оболочки, дна скважины, дна котлована;<br />
        в графе 11 - до начала бетонирования при опущенной трубе это длина трубы от точки отсчёта до её конца, в процессе бетонирования - отсчёт по делениям, нанесённым на трубу;<br />
        в графах 12, 13, 14, 15, 16 - глубина от точки отсчёта до уложенного бетона и трубы в контрольных точках (измеряется футштоками или лотами);<br />
        в графе 17 - разность отсчётов по делениям на трубах с отметкой уровня бетона у трубы;<br />
        в графе 18 - средний уклон поверхности бетона, определяемый по результатам граф 11, 12, 13, 14, 15;<br />
        в графе 19 - разница между длиной всей трубы и глубиной от верха трубы до бетона в трубе, измеряемого лотом.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: [ 'project', 'journal', ],
  data: () => ({
    data: [],
  }),
  computed: {
    columns() {
      if (!this.journal?.front) {
        return []
      } else {
        return [
          ...this.journal.front.index[2].content,
          { name: 'tools', title: '', },
        ]
      }
    },
    createRecordLink() {
      return { query: { ...this.$route.query, 'new-record': null, }, }
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journalsOld.records.get(this.project.id, this.$route.params.journal, 'records').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
